/*
 * @Description: 接口
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
/**
 * 服务端接口地址集
 */

export default {
  getLogAndAnnouncement: {
    url: '/api/announcement/updatelogandannouncement', // 获取公告
    method: 'GET',
  },
  readLogContent: {
    url: '/api/index/haveRead', //日志已读
    method: 'GET',
    hasPathParams: true,
  },
  readAllContent: {
    url: '/api/index/haveReadAll', //日志全部已读
    method: 'GET',
    hasPathParams: true,
  },
  getPopubWin: {
    url: '/api/market/getPopubWin',  // 获取弹窗
    method: 'POST',
  },
  getIndexPeople: {
    url: '/api/index/getIndexPeople', //获取顶部top人数
    method: 'POST',
  },
  getOrderPieChart: {
    url: '/api/index/getOrderPieChart', //获取昨日订单数
    method: 'POST',
  },
  getPaymentPercentage: {
    url: '/api/index/getPaymentPercentage', //付款占比
    method: 'POST',
  },
  getOrderPieChartData: {
    url: '/api/index/getOrderPieChartData', //获取昨日订单数
    method: 'POST',
  },
  getHelpList: {
    url: '/api/announcement/helpcenter', //获取帮助列表
    method: 'GET',
  },
  getQuickOperation: {
    url: '/api/index/getQuickOperation', //获取快捷操作
    method: 'GET',
  },
  getTrendData: {
    url: '/api/index/getTrend', //趋势图
    method: 'GET',
    hasPathParams: true,
  },
  getFullLink: {
    url: '/api/index/getOpenStatus', //订单关怀全链路状态
    method: 'GET',
    hasPathParams: true,
  },
  getCanlendar: {
    url: '/api/index/getActivityCalendar', //日历
    method: 'GET',
    hasPathParams: true,
  },
  saveQuickOperation: {
    url: '/api/index/saveQuickOperation', //保存快捷操作
    method: 'GET',
    hasPathParams: true,
  },
  getIndexPeopleRight: { //获取top人群右边占比
    url: '/api/index/getIndexPeopleRight',
    method: 'POST',
  },
  getIndexPeopleReach: { //获取top人数触达
    url: '/api/index/getIndexPeopleReach',
    method: 'POST',
  },
  getIndexPeopleLeft: { //获取top人数概况与分析
    url: '/api/index/getIndexPeopleLeft',
    method: 'POST',
  },
  getActivitySummary: { //获取营销活动数
    url: '/api/index/getActivitySummary',
    method: 'GET',
    hasPathParams: true,
  },
  getAnnouncement: { //获取顶部公告
    url: '/api/index/getAnnouncement',
    method: 'POST',
  },
  getShopTitle: { //获取店铺信息
    url: '/api/index/getShopTitle',
    method: 'POST',
  },
  updatePhone: { //修改手机号
    url: '/api/index/updatePhone',
    method: 'GET',
    hasPathParams: true,
  },
  getUpdateLog: { //获取更新日志
    url: '/api/index/getUpdateLog',
    method: 'POST',
  },
  ignoreUpdateLog: { //忽略更新日志
    url: '/api/index/ignoreUpdateLog',
    method: 'POST',
  },
  getTrendCard: { //新会员开卡趋势
    url: '/api/index/getTrendCard',
    method: 'GET',
    hasPathParams: true,
  },
  getTrendMemberBuying: { //会员购买趋势
    url: '/api/index/getTrendMemberBuying',
    method: 'GET',
    hasPathParams: true,
  },
  getTrendMemberPurchase: { //会员购买率
    url: '/api/index/getTrendMemberPurchase',
    method: 'GET',
    hasPathParams: true,
  },
  getTrendNewCustomers: { //店铺新客趋势
    url: '/api/index/getTrendNewCustomers',
    method: 'GET',
    hasPathParams: true,
  },
  getTrendOldCustomers: { //店铺老客复购趋势
    url: '/api/index/getTrendOldCustomers',
    method: 'GET',
    hasPathParams: true,
  },
  getTrendRepurchaseRate: { //复购率
    url: '/api/index/getTrendRepurchaseRate',
    method: 'GET',
    hasPathParams: true,
  },
  getCheckCold: { //判断冷商家
    url: '/api/user/cold/check',
    method: 'POST',
  },
  getDataCompletion: { //判断如果是冷商家就调这个接口
    url: '/api/index/dataCompletion',
    method: 'POST',
  },
  getNewShopCheck: { //判断如果是热商家就调这个接口
    url: '/api/index/newShopCheck',
    method: 'POST',
  },
  getLabelStatus: { //键盘调的接口
    url: '/api/index/labelStatus',
    method: 'GET',
  },
  linkTocjhy: { //跳转到超级会员
    url: '/api/biz/user/cjyxLoginPersonal',
    method: 'POST',
  },
  getSmsCalendar: { // 获取短信营销日历
    url: '/api/marketing/calendar/smscalendar',
    method: 'GET'
  },
  getSmsCalendarSummary: { //获取短信营销日历汇总
    url: '/api/marketing/calendar/smscalendarsummary',
    method: 'GET'
  },
  getRoi: { // 获取roi
    url: '/api/smseffect/roi',
    method: 'GET'
  },
  getSalesData: { //获取首页销售情况(未开启催付接口)
    url: '/api/callforpayment/salesdata',
    method: 'GET'
  },
  getOpenSalesData: { //获取首页销售情况(已开启催付接口)
    url: '/api/sms/doudiansingle/effect/salesdata',
    method: 'GET'
  },
  getPaymentChart: { //首页付款占比
    url: '/api/callforpayment/paymentchart',
    method: 'GET'
  },
  getShopSurvey: { // 获取首页店铺概况
    url: '/api/crowd/analysis/index',
    method: 'GET'
  },
  getShopChart: { //获取首页店铺概况趋势图
    url: '/api/crowd/analysis/indexchart',
    method: 'GET'
  },

  // 人群相关
  // 标签创建人群
  getLabelNum: { //获取标签数量
    url: '/api/crowd/labelcount',
    method: 'GET'
  },
  getPublicPeopleTag: { // 官方标签筛选-获取人群标签
    url: '/api/crowd/manage/labellist',
    method: 'GET',
    hasPathParams: true,
  },
  getThreeCategory: { // 官方标签筛选-查询三级品类
    url: '/api/crowdpackage/crowditem',
    method: 'GET',
  },
  getThreelevel: { // 获取大促三级类目偏好
    url: '/api/category/label/threelevel',
    method: 'GET',
  },
  getProvince: { // 官方标签筛选-查询所有省市
    url: '/api/area/citiesandcountys',
    method: 'GET',
  },
  getKeyWord: { // 官方标签筛选-查询top100关键词
    url: '/api/crowdpackage/searchwords',
    method: 'GET',
  },
  crowdEstimate: { // 官方标签筛选-人群预估
    url: '/api/crowd/manage/precalculate',
    method: 'POST',
  },
  createCrowd: { // 官方标签筛选-创建人群
    url: '/api/crowd/manage/createcrowd',
    method: 'POST',
  },
  newcreateCrowd: { // 官方标签筛选-创建人群
    url: '/api/crowd/manage/newcreateCrowd',
    method: 'POST',
  },
  newprecalculate:{
    url: '/api/crowd/manage/newprecalculate',
    method: 'POST',
  },
  copyCrows: { // 官方标签筛选-复制人群
    url: '/api/crowd/manage/createcrowd',
    method: 'GET',
  },
  crowdpackreplica: { //订单筛选/手机号上传人群复制
    url: '/api/crowd/crowdpackreplica',
    method: 'POST',
  },
  getGoodsSku: { //获取商品sku
    url: '/api/sku/skus',
    method: 'GET',
  },
  getGoodsSpu: { //获取商品spu
    url: '/api/sku/spus',
    method: 'GET',
  },
  getMarketingtasksList: { //获取【精准营销】--[人群营销] -- {列表数据}
    url: '/api/marketingtasksnew/list',
    method: 'GET',
  },
  getMarketingtasksListOld: { //获取【精准营销】--[人群营销] -- {列表数据}
    url: '/api/marketingtasks/list',
    method: 'GET',
  },
  getSmsEffectList: { //获取【精准营销】--[人群营销] --[营销效果]--- {列表数据}
    url: '/api/smseffect/data',
    method: 'GET',
  },
  getSmsEffectDatasummary: { //获取【精准营销】--[人群营销] --[营销效果]--- {获取详细效果数据}
    url: '/api/smseffect/datasummary',
    method: 'GET',
  },
  downloadSmsEffectData: { //获取【精准营销】--[人群营销] --[营销效果]--- {获取详细效果数据 -导出}
    url: '/api/smseffect/dataout',
    method: 'GET',
    isDownload: true
  },
  getOrderlifecycle: { //获取【精准营销】--[订单筛选营销] -- [订单筛选]--{进度条数据}
    url: '/api/orders/orderlifecycle',
    method: 'GET'
  },
  getOrderlifecyclesum: { //获取【精准营销】--[订单筛选营销] -- [订单筛选]--{数据可视化数据}
    url: '/api/orders/orderlifecyclesum',
    method: 'GET',
  },
  getOrdersList: { //获取【精准营销】--[订单筛选营销]--{列表数据}
    url: '/api/orders/ordertablelist',
    method: 'POST',
  },
  getSmsTemplate: { // 获取营销短信模板列表
    url: '/api/sms/doudiansmsmodel/templatelist',
    method: 'GET',
  },
  smsUseaccountAdd: { // 短信模板使用一次后，使用次数加1
    url: '/api/sms/doudiansmsmodel/templatecountadd',
    method: 'POST',
  },
  postMarketingtask: { //获取【精准营销】--[新建官方人群营销]--{表单}
    url: '/api/marketingtasksnew/marketingtask',
    method: 'POST',
  },
  deleteMarketingtask: { //删除 【精准营销】--[新建官方人群营销]--{列表}-取消推送
    url: '/api/marketingtasksnew/marketingtask/{Id}',
    method: 'DELETE',
    hasPathParams: true,
  },
  postMarketingtaskOld: { //获取【精准营销】--[新建官方人群营销]--{表单}
    url: '/api/marketingtasks/marketingtask',
    method: 'POST',
  },
  deleteMarketingtaskOld: { //删除 【精准营销】--[新建官方人群营销]--{列表}-取消推送
    url: '/api/marketingtasks/marketingtask/{Id}',
    method: 'DELETE',
    hasPathParams: true,
  },

  getPaymentRecord: {//短信充值记录
    url: '/api/account/paymentrecord',
    method: 'GET',
  },
  alipay: { // 支付宝充值短信
    url: '/api/account/alipayapi',
    method: 'PUT',
  },
  alipaySecond: { // 支付宝充值短信
    url: '/api/account/alipayapiagain/{outTradeNo}',
    method: 'PUT',
    hasPathParams: true,
  },
  getAccountPayment: {//获取【账户管理】--[一、短信充值]--{列表数据}
    url: '/api/account/payment/{shopId}',
    method: 'GET',
    hasPathParams: true,
  },
  getPaymentSMSNum: {//获取【账户管理】--[二、充值记录]--{列表数据}
    url: '/api/account/paymentrecord',
    method: 'GET',
  },
  //  短信消耗记录
  getDoudiansmsconsumelist: {//获取【账户管理】--[三、消耗记录]--{页面获取消耗记录列表}
    url: '/api/sms/doudiansmsconsume/doudiansmsconsumelist',
    method: 'GET',
  },
  getCareDetails: {  // 短信发送明细（订单关怀）
    url: '/api/sms/doudiansmsconsume/doudiancaresmsdetails',
    method: 'GET',
  },
  getSmssignlog: {//获取【账户管理】--[四、签名备案]--{页面获取签名备案列表}
    url: '/api/sms/doudiansms/smssignlist',
    method: 'GET',
  },
  putSmssignmodify: {//获取【账户管理】--[四、签名备案]--{修改短信签名}
    url: '/api/sms/doudiansms/smssignmodify',
    method: 'PUT',
  },
  setDefaultSign: { // 设置默认签名
    url: '/api/sms/doudiansms/choosedefault',
    method: 'PUT',
  },
  getCrowdDetails: {   // 短信发送明细（营销）
    url: "/api/sms/doudiansmsconsume/doudiancrowdsmsdetails",
    method: 'GET'
  },
  getTestDetails: {  // 测试短信发送明细
    url: "/api/sms/doudiansmsconsume/doudiantestsmsdetails",
    method: 'GET'
  },
  ExportCareSms: {  // 短信发送明细（订单关怀）导出
    url: '/api/sms/doudiansmsconsume/doudiancaresmsxecelout',
    method: 'GET',
    isDownload: true
  },
  ExportCrowdSms: {  // 短信发送明细（营销）导出
    url: '/api/sms/doudiansmsconsume/doudiancrowdsmsexcelout',
    method: 'GET',
    isDownload: true
  },
  ExportTestSms: {   // 测试短信发送明细导出
    url: '/api/sms/doudiansmsconsume/doudiantestsmsconsumeexcelout',
    method: 'GET',
    isDownload: true
  },
  getDyWaiterUserBlackList: {  // 获取黑名单列表
    url: "/api/blackpins/blackpinlist",
    method: 'GET',
  },
  deleteDyBlackPin: {  // 解除黑名单
    url: '/api/blackpins/blackpin',
    method: 'DELETE'
  },
  enterDyBlackPin: {   // 手动录入黑名单
    url: '/api/blackpins/blackpin',
    method: 'PUT'
  },
  getDYCrowdList: {   // 根据条件查询人群列表
    url: '/api/crowd/manage/crowdlist',
    method: "GET"
  },
  DeleteCrowdById: {  // 根据id批量删除人群
    url: '/api/crowd/manage/deletecrowds',
    method: 'POST',
  },
  downLoadPhoneTemplate:{
    url:'/api/crowd/phoneexport',
    method:'GET',
    isDownload: true
  },
  crowdMerge: {      // 手机号上传人群
    url: '/api/crowd/phonenumberupload',
    method: "POST"
  },
  savePhoneAsCrowd: {      // 订单筛选批量保存人群包
    url: '/api/crowd/phonens',
    method: "POST",
  },
  // 订单关怀功能模块
  saveCallforpayment: { // 保存订单催付
    url: '/api/callforpayment/tasks',
    method: 'POST',
  },
  getSameName: {     //催付任务名是否相同
    url: '/api/callforpayment/tasks/name',
    method: 'GET',
  },
  getProvinces: { //查询省份
    url: '/api/area/provinces',
    method: 'GET',
  },
  getCity: {
    url: "/api/area/citiesandcountys",
    method: 'GET'
  },
  getSmsModel: {      // 获取短信模板
    url: '/api/subsms/sms/single/model/available',
    method: 'POST',
  },
  getPaymentList: { //订单催付任务列表
    url: '/api/callforpayment/tasks',
    method: 'GET',
  },
  getSendAndRemain: {  // 当前taskId的发送量和限定剩余
    url: '/api/callforpayment/surplus',
    method: 'GET',
  },
  deletePaymentList: { //删除订单催付任务
    url: '/api/callforpayment/task/{taskId}',
    method: 'DELETE',
    hasPathParams: true,
  },
  updatePaymentList: {   // 更新订单催付任务
    url: '/api/callforpayment/task/{taskId}',
    method: 'PUT',
    hasPathParams: true
  },
  getPaymentRecordList: { //催付记录汇总列表
    url: '/api/sms/doudiansingle/effect/singlerecords',
    method: 'GET',
  },
  getOrdersandSmsAmount: { //催付订单数/发送短信总量
    url: '/api/subsms/single/effect/ordersandsmsamount',
    method: 'GET',
  },
  getPaymentEffectList: { //催付效果汇总列表
    url: '/api/sms/doudiansingle/effect/singleeffects',
    method: 'GET',
  },
  getPaymentEffectSummary: { //催付效果汇总
    url: '/api/sms/doudiansingle/effect/summary',
    method: 'GET',
  },
  getTemplateRanking: { // 短信模板榜单
    url: '/api/subsms/single/effect/singletemplatesranking',
    method: 'GET',
  },
  getRecordExcelout: { //催付记录导出
    url: '/api/sms/doudiansingle/effect/singlerecordsexcelout',
    method: 'GET',
    isDownload: true
  },
  sendTestsms: { //发送测试短信
    url: '/api/sms/doudiansms/testsms',
    method: 'POST',
  },
  createShortLink: { //生成短链接
    url: '/api/sms/doudiansms/createshortlink',
    method: 'GET',
  },
  getTitle: { // 获取店铺信息
    url: '/api/index/title',
    method: 'GET',
  },
  updateStoreBindTel: { // 更新店铺所绑定的手机号
    url: '/api/index/telphone/{phone}',
    method: 'PUT',
    hasPathParams: true,
  },
  getTimeSuccessRate: { //催付时间分析
    url: '/api/subsms/single/effect/singletimesuccessrate',
    method: 'GET',
  },
  getEffectExcelout: { //效果列表导出
    url: '/api/sms/doudiansingle/effect/singleeffectsexcelout',
    method: 'GET',
    isDownload: true
  },
  // getFirstRecord: { // 催付记录(一次&二次)
  //   url: '/api/single/effect/singlerecords',
  //   method: 'GET',
  // },
  getPaymentAmount: { // 催付订单数/发送短信总量
    url: '/api/sms/doudiansingle/effect/ordersandsmsamount',
    method: 'GET',
  },
  // exportPaymentRecord: { // 催付记录导出
  //   url: '/api/subsms/single/effect/singlerecordsexcelout',
  //   method: 'GET',
  //   isDownload: true
  // },
  switchMission: { // 开启关闭订单催付任务
    url: '/api/callforpayment/task/{taskId}/activation/{activation}',
    method: 'PUT',
    hasPathParams: true,
  },

  getSmssign: { //获取短信签名
    url: '/api/sms/doudiansms/smssign',
    method: 'GET'
  },
  getSmsNum: { //获取短信余额
    url: '/api/subsms/smsaccountpay/getsmsnum',
    method: 'GET'
  },
  getPageSmsNum: { //获取页面获取短信余额方法
    url: '/api/account/smsnum',
    method: 'GET'
  },

  getSignphone: {  //商家短信手机号查询接口
    url: '/api/subsms/smsmasssend/getsignphone',
    method: 'GET'
  },
  getDouDianSMS: {  //获取抖音模板列表
    url: '/api/sms/doudiansmsmodel/templatelist',
    method: 'GET'
  },
  smsTemplateApply:{ //短信模板申请
    url:'/api/sms/doudiansmsmodel/templateapply',
    method:'POST'
  },
  smsTemplateDelete:{//短信模板删除
    url:'/api/sms/doudiansmsmodel/templatedelete',
    method:'POST'
  },
  smsModelType:{ //获取短信模板类型
    url:'/api/sms/doudiansmsmodel/smsmodeltype',
    method:'GET'
  },
  getSmsShortLink:{ //获取短链
    url:'/api/sms/doudiansmsmodel/smsshortlink',
    method:'GET'
  },
  applyTemplate:{ //短信模板申请
    url:'/api/sms/doudiansmsmodel/templateapply',
    method:'POST'
  },
  getSmsModelTypeList:{ //获取短信模板类型(简易)
    url:'/api/sms/doudiansmsmodel/smsmodeltypelist',
    method:'GET'
  },

  // 营销效果数据
  getEffectData: { // 效果数据
    url: '/api/sms/doudiansms/effect/data',
    method: 'POST'
  },
  getEffectDataExcelout: { // 效果数据导出
    url: '/api/sms/doudiansms/effect/effectexcelout',
    method: 'GET',
    isDownload: true
  },
  getUnitPrice: { // 获取单价
    url: '/api/sms/doudiansms/effect/unitprice',
    method: 'GET'
  },
  updateUnitPrice: { // 修改单价
    url: '/api/sms/doudiansms/effect/unitpricemodify',
    method: 'POST'
  },

  // 订单关怀效果数据
  getOrderCareSummaryOne: {
    url: '/api/ordercare/effecttotal',
    method: 'GET'
  },
  getOrderCareTableOne: {
    url: '/api/ordercare/effectlist',
    method: 'GET'
  },
  exportOrderCareSummaryDetail: {
    url: '/api/ordercare/effectexport',
    method: 'GET',
    isDownload: true
  },
  getOrderCareCPSummaryOne: {
    url: '/api/ordercare/cpeffecttotal',
    method: 'GET'
  },
  getOrderCareCPTableOne: {
    url: '/api/ordercare/cpeffectlist',
    method: 'GET'
  },
  exportOrderCareCPSummaryDetail: {
    url: '/api/ordercare/cpeffectexport',
    method: 'GET',
    isDownload: true
  },
  // 订单关怀列表
  getOrderCareList: { // 任务列表
    url: '/api/ordercare/tasks',
    method: 'GET'
  },
  deleteOrderCareList: { // 删除任务
    url: '/api/ordercare/task/{taskId}',
    method: 'DELETE',
    hasPathParams: true,
  },
  activeOrderCareList: { // 启用/关闭任务
    url: '/api/ordercare/task/active?taskId={taskId}&active={active}',
    method: 'PUT',
    hasPathParams: true,
  },
  getOrderTaskOpenStatus: {  // 获取各类型功能是否开通
    url: '/api/ordercare/opentasktype',
    method: 'GET'
  },
  getDyToken: { // 抖音获取前端组件token
    url: '/api/authorization/mcToken',
    method: 'GET'
  },
  saveOrderCare: { //保存订单关怀任务
    url: '/api/ordercare/tasks',
    method: 'POST'
  },
  getOrderCareDetail: { //获取订单关怀任务详情
    url: '/api/ordercare/taskdetail',
    method: 'GET'
  },
  getOrderCareTasksName: { //订单关怀任务名接口
    url: '/api/ordercare/tasks/name',
    method: 'GET'
  },
  getOrderCareTasksPriority: { //获取已存在的优先级
    url: '/api/ordercare/taskpriority',
    method: 'GET'
  },
  setMobileSmsCode: {//发送手机验证码
    url: '/api/mobileverificationcode/mobileverificationcodesend',
    method: 'GET',
  },
  savePhoneNumber: {//修改绑定手机号
    url: '/api/mobileverificationcode/bindingphone',
    method: 'POST',
  },

  // 短信消耗记录
  getSmsActivityType: { // 查询短信活动类型
    url: '/api/sms/doudiansmsconsume/doudiansmstasktypeenum',
    method: 'GET'
  },
  getConsumptionRecord: { // 获取短信消耗记录
    url: '/api/sms/doudiansmsconsume/doudiansmsconsumelist',
    method: 'GET'
  },
  getConsumptionDetail: { // 获取短信发送明细
    url: '/api/sms/doudiansmsconsume/doudiansmsconsumedetails',
    method: 'GET'
  },
  exportConsumptionDetail: { // 导出短信发送明细
    url: '/api/sms/doudiansmsconsume/doudianconsumedetaildataexcelout',
    method: 'GET'
  },
  getOrderCareDetailData: { // 查询订单关怀任务明细
    url: '/api/sms/doudiansmsconsume/doudiancaresmstaskdetails',
    method: 'GET'
  },
  exportOrderCareDetailData: { // 导出订单关怀任务明细
    url: '/api/sms/doudiansmsconsume/doudiancaresmstaskdetailsexcelout',
    method: 'GET'
  },
  getTestSmsStatus: { // 刷新测试短信状态
    url: '/api/sms/doudiansms/testsmsresult',
    method: 'GET'
  },

  // 获取人群包类型下拉列表
  getCrowdTypeList: {
    url: '/singleCode/crowdTypeList',
    method: 'GET',
  },

  // 获取协议
  getProtocol: {
    url: '/api/agreement',
    method: 'GET',
  },
  // 签署协议
  signProtocol: {
    url: '/api/agreement/sign',
    method: 'POST',
  },
}
